import { render, staticRenderFns } from "./WarrantyBillItemV2.vue?vue&type=template&id=36a65245&scoped=true"
import script from "./WarrantyBillItemV2.vue?vue&type=script&lang=js"
export * from "./WarrantyBillItemV2.vue?vue&type=script&lang=js"
import style0 from "./WarrantyBillItemV2.vue?vue&type=style&index=0&id=36a65245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a65245",
  null
  
)

export default component.exports